var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7365_38069)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6666 7.00008C18.0833 7.31675 18.3333 7.80841 18.3333 8.33341V16.6667C18.3333 17.1088 18.1577 17.5327 17.8451 17.8453C17.5326 18.1578 17.1087 18.3334 16.6666 18.3334H3.33329C2.89127 18.3334 2.46734 18.1578 2.15478 17.8453C1.84222 17.5327 1.66663 17.1088 1.66663 16.6667V8.33341C1.66663 8.07467 1.72687 7.81948 1.84258 7.58806C1.95829 7.35663 2.1263 7.15533 2.33329 7.00008L8.99996 2.00008C9.28845 1.78371 9.63934 1.66675 9.99996 1.66675C10.3606 1.66675 10.7115 1.78371 11 2.00008L17.6666 7.00008Z",
    stroke: "#DA334E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 8.33325L10.8583 13.0833C10.601 13.2444 10.3036 13.3299 9.99996 13.3299C9.69636 13.3299 9.3989 13.2444 9.14163 13.0833L1.66663 8.33325",
    stroke: "#DA334E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7365_38069"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.f643ac018a3c4eb0e81b456b0e7dac9f.svg";
export { ForwardRef as ReactComponent };